module.exports = __webpack_public_path__ + "static/media/map-screenshot.c96b0a8e.png";